module.exports = __webpack_public_path__ + "img/BrandMe_IA_LevantandoCopa_10.dee3a6bd.png";